// Shared math/formatting for the air manual quote charge tables.
// Kept framework-free so both the line-item editor and the option/airline
// summary totals compute a row's amount the exact same way.

export const money = (n) =>
  `INR ${Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const rowTotal = (item, totalWeight) => {
  const rate = Number(item?.unitRate) || 0;
  if (item?.unit === "perkg") return rate * (Number(totalWeight) || 0);
  return rate;
};

export const sectionTotal = (items, totalWeight) =>
  (items || []).reduce((sum, item) => sum + rowTotal(item, totalWeight), 0);

export const optionGrandTotal = (option, totalWeight) =>
  sectionTotal(option?.charges?.origin?.items, totalWeight) +
  sectionTotal(option?.charges?.destination?.items, totalWeight) +
  sectionTotal(option?.charges?.freightAndSurcharges?.items, totalWeight);

export const airlineGrandTotal = (airline, totalWeight) =>
  (airline?.flightOptions || []).reduce(
    (sum, option) => sum + optionGrandTotal(option, totalWeight),
    0
  );
